import { http } from "../../../config/HttpMethod";
import { JETLIFT_ENDPOINTS } from "../../../store/jetlift/endpoints";
import { DepletionCurveGraphData, DepletionCurvePayload, DepletionPercentageInObject, FutureBHPInObject, IPRGraphData, IPRGraphPayload, IPRTableData } from "../../../store/model/calculations/calculation";
import { basicSummaryPayload, basicSummaryResponse, basicSummaryScenariosPayload, DepletionPressurePayload, IPRTablePayload } from "../../../store/model/jetlift/jetlift";

// Add this interface
export interface TailPipe {
    tailPipeDesander: number;
    transitionZone: number;
    tailPipeBttm: number;
}

// Async API Call for IPR Data

export const getIPRTableData = async (postData: IPRTablePayload): Promise<IPRTableData | null> => {
    try {
        const response = await http.post<IPRTableData>(`${JETLIFT_ENDPOINTS?.GET_WELL_INFLOW_LIST}`, postData);
        return response?.data || null;
    } catch (err) {
        console.error("Error fetching TDH data:", err);
        return null;
    }
};

export const getDepletionCurveData = async (postData: DepletionCurvePayload) => {
    try {
        const response = await http.post<DepletionCurveGraphData>(
            `${JETLIFT_ENDPOINTS?.GET_DEPLETION_GRAPH_DATA}`, postData
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching Depletion Curve Data", err);
        return null;
    }
};
export const getIPRGraphData = async (postData: IPRGraphPayload): Promise<IPRGraphData | null> => {
    try {
        const response = await http.post<IPRGraphData>(`${JETLIFT_ENDPOINTS?.GET_IPR_GRAPH_DATA}`, postData);
        return response?.data || null;
    } catch (err) {
        console.error("Error fetching IPR Graph Data:", err);
        return null;
    }
};

export const GetDepletionPercentage = async (depletionPercentageInObject: DepletionPercentageInObject) => {
    try {
        const response = await http.post<number>(`${JETLIFT_ENDPOINTS?.GET_DEPLETION_PERCENTAGE}`, depletionPercentageInObject);
        return response?.data;
    } catch (err) {
        console.error("Error fetching Depletion Percentage:", err);
    }
};

export const GetFutureBHP = async (futureBHPObject: FutureBHPInObject) => {
    try {
        const response = await http.post<number>(`${JETLIFT_ENDPOINTS?.GET_FUTURE_BHP}`, futureBHPObject);
        return response?.data;
    } catch (err) {
        console.error("Error Fetching Future BHP:", err);
    }
};

export const GetFutureProductionRate = async (projectId: string) => {
    try {
        const response = await http?.get<number>(`${JETLIFT_ENDPOINTS?.GET_FUTURE_PRODUCTION_RATE}`, projectId ? { params: { projectId } } : undefined);
        return response?.data || 0;
    } catch (err) {
        console.error("Error fetching Future Production Rate:", err);
    }
};

export const GetDepletionPressure = async (payload: DepletionPressurePayload) => {
    try {
        const response = await http?.post<number>(`${JETLIFT_ENDPOINTS?.GET_DEPLETION_PRESSURE}`, payload);
        return response?.data || 0;
    } catch (err) {
        console.error("Error fetching Depletion Pressure:", err);
    }
};

export const basicCalculationService = {
    getTailPipeTZ: async (postData: any) => {
        try {
            const response = await http.post('/2.0/Determine/Calculation/GetTailPipeTZ', postData);
            return response.data;
        } catch (error) {
            console.error('Error calculating TailPipe TZ:', error);
            return 0;
        }
    }

};

// Add this new export
export const getTailPipeTZ = async (postData: TailPipe): Promise<number> => {
    try {
        const response = await http.post<number>('/2.0/Determine/Calculation/getTailPipeTZ', postData);
        return response?.data || 0;
    } catch (err) {
        console.error("Error calculating Tail Pipe TZ:", err);
        return 0;
    }
};

export const GetBasicSummary = async (payload: basicSummaryPayload) => {
    try {
        const response = await http.post<basicSummaryResponse>(`${JETLIFT_ENDPOINTS?.GET_BASIC_SUMMARY}`, payload);
        return response?.data;
    } catch (err) {
        console.error("Error fetching iprcurve scenatios", err);
        return null;
    }
};

export const GetBasicSummaryScenarios = async (payload: basicSummaryScenariosPayload) => {
    try {
        const response = await http.post(`${JETLIFT_ENDPOINTS?.GET_BASIC_SUMMARY_SCENARIOS}`, payload);
        return response?.data;
    } catch (err) {
        console.error("Error fetching iprcurve scenatios", err);
        return null;
    }
};
